import service from "@/services/apartment";

const apartment = {
  namespaced: true,
  state: {
    apartment: {},
    residents: [],
    cars: [],
    notifications: {},
    invoicing: {},
  },
  getters: {
    getApartmentMainData: (state) => {
      return state.apartment;
    },
    getApartmentResidents: (state) => {
      return state.residents;
    },
    getApartmentCars: (state) => {
      return state.cars;
    },
    getApartmentUsers: (state) => {
      return state.residents.map((a) => a.user).filter((x) => !!x);
    },
    getApartmentNotifications: (state) => {
      return state.notifications;
    },
    getApartmentInvoicing: (state) => {
      return state.invoicing;
    },
  },
  mutations: {
    setApartmentInfo(state, data) {
      state.apartment = { ...data };
    },
    setApartmentResidents(state, data) {
      state.residents = [...data];
    },
    setApartmentCars(state, data) {
      state.cars = [...data];
    },
    setApartmentNotifications(state, data) {
      state.notifications = { ...data };
    },
    setApartmentInvoicing(state, data) {
      state.invoicing = { ...data };
    },
  },
  actions: {
    async fetchAllApartmentData({ dispatch }, { cId, aId }) {
      try {
        await Promise.all([
          dispatch("fetchApartmentResidents", { cId: cId, aId: aId }),
          dispatch("fetchApartmentData", { cId: cId, aId: aId }),
          dispatch("fetchApartmentCars", { aId: aId, cId: cId }),
          dispatch("fetchApartmentNotifications", { aId: aId }),
          dispatch("fetchApartmentInvoicing", { aId: aId }),
        ]);
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentData({ commit }, { cId, aId }) {
      try {
        const data = await service.getApartmentData(cId, aId);
        commit("setApartmentInfo", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentResidents({ commit }, { cId, aId }) {
      try {
        const data = await service.getApartmentResidents(cId, aId);
        commit("setApartmentResidents", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentCars({ commit }, { aId, cId }) {
      try {
        const data = await service.getApartmentCars(aId, cId);
        commit("setApartmentCars", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentNotifications({ commit }, { aId }) {
      try {
        const data = await service.getApartmentNotifications(aId);
        commit("setApartmentNotifications", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentInvoicing({ commit }, { aId }) {
      try {
        const data = await service.getApartmentInvoicing(aId);
        commit("setApartmentInvoicing", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default apartment;
